<div *ngIf="content?.cards?.length > 0">
  <eds-carousel-slider
    [preTitle]="content.preTitle"
    [titleLabel]="content.title"
    [textContent]="processedText"
    [linkContentUrl]="content.link?.url"
    [linkContent]="content.link?.displayText"
    [sliderItems]="cards"
    [prevPageText]="labels?.previous | translate"
    [nextPageText]="labels?.next | translate"
    [signInTooltip]="'common.locked-link-tooltip' | translate"
    [carouselBackgroundTheme]="carouselTheme"
    [theme]="titleColorTheme"
    [linkContentIsNewWindow]="content?.link?.target"
    [linkContentIsExternal]="content?.link?.external"
    [hideLockIcon]="content?.link?.hideLockIcon"
    [hasLeftIcon]="content?.link?.hideLockIcon"
    [signInRequired]="content?.link?.signInLink && !this.isLoggedIn"
    (onCardClicked)="setDownloadLocation($event)"
    [footnote]="content?.footnote?.value"
  ></eds-carousel-slider>
</div>
